// extracted by mini-css-extract-plugin
export default {"contactInfoLabel":"Contacts_contactInfoLabel__yFiGM","contactInfoValue":"Contacts_contactInfoValue__60kld"};